import React from 'react';

export default function Footer() {
  return (
    <footer>
      <p>&copy;2017-{new Date().getFullYear()} Cowart Consulting Group </p>
    </footer>
  );
}